import { render, staticRenderFns } from "./DxBatchesInfoForm.vue?vue&type=template&id=1b4c6c42&scoped=true&"
import script from "./DxBatchesInfoForm.vue?vue&type=script&lang=js&"
export * from "./DxBatchesInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c6c42",
  null
  
)

export default component.exports